"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_hook_form_1 = require("react-hook-form");
var components_1 = require("@/components");
var Styled = __importStar(require("./SessionTemplate.styled"));
var plus_20_svg_1 = __importDefault(require("@/assets/svg/plus-20.svg"));
var minus_20_svg_1 = __importDefault(require("@/assets/svg/minus-20.svg"));
var ContentTemplate_1 = require("../ContentTemplate");
var time_16_svg_1 = __importDefault(require("@/assets/svg/time-16.svg"));
var utils_1 = require("@/utils");
var DEFAULT_CONTENT = {};
var SessionTemplate = function (_a) {
    var _b, _c;
    var index = _a.index, onRemove = _a.onRemove, errors = _a.errors;
    var _d = (0, react_hook_form_1.useFormContext)(), register = _d.register, control = _d.control;
    var _e = (0, react_hook_form_1.useFieldArray)({
        name: "sessions.".concat(index, ".contentsCreateRequests"),
        control: control,
    }), fields = _e.fields, append = _e.append, remove = _e.remove;
    var handleRemoveSession = function () {
        onRemove(index);
    };
    return ((0, jsx_runtime_1.jsxs)(Styled.SessionTemplateWrapper, { children: [(0, jsx_runtime_1.jsx)(components_1.InputField, __assign({ "$size": "md", label: "\uC138\uC158\uBA85", placeholder: "\uC138\uC158\uBA85\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694", required: true }, register("sessions.".concat(index, ".name"), { required: true })), void 0), (0, jsx_runtime_1.jsxs)(Styled.SessionTimeInputLabel, { children: ["\uC138\uC158 \uC9C4\uD589 \uC2DC\uAC04", (0, jsx_runtime_1.jsx)(Styled.RequiredDot, {}, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)(Styled.SessionTimeInputWrapper, { children: [(0, jsx_runtime_1.jsx)(Styled.SessionTimeInput, __assign({ "$size": "md", endIcon: (0, jsx_runtime_1.jsx)(time_16_svg_1.default, {}, void 0), placeholder: "13:00", errorMessage: (_b = errors === null || errors === void 0 ? void 0 : errors.startedAt) === null || _b === void 0 ? void 0 : _b.message }, register("sessions.".concat(index, ".startedAt"), {
                        required: true,
                        pattern: {
                            value: utils_1.TIME_REGEX,
                            message: '시간 형식이 올바르지 않습니다,',
                        },
                    })), void 0), (0, jsx_runtime_1.jsx)(Styled.SessionTimeInput, __assign({ "$size": "md", endIcon: (0, jsx_runtime_1.jsx)(time_16_svg_1.default, {}, void 0), placeholder: "13:45", errorMessage: (_c = errors === null || errors === void 0 ? void 0 : errors.endedAt) === null || _c === void 0 ? void 0 : _c.message }, register("sessions.".concat(index, ".endedAt"), {
                        required: true,
                        pattern: {
                            value: utils_1.TIME_REGEX,
                            message: '시간 형식이 올바르지 않습니다,',
                        },
                    })), void 0)] }, void 0), (0, jsx_runtime_1.jsxs)(Styled.ContentTemplateWrapper, { children: [fields.map(function (field, fieldIndex) {
                        var _a;
                        return ((0, jsx_runtime_1.jsx)(ContentTemplate_1.ContentTemplate, { name: "sessions.".concat(index, ".contentsCreateRequests"), index: fieldIndex, onRemove: remove, errors: (_a = errors === null || errors === void 0 ? void 0 : errors.contentsCreateRequests) === null || _a === void 0 ? void 0 : _a[index] }, field.id));
                    }), (0, jsx_runtime_1.jsxs)(Styled.AddButton, __assign({ onClick: function () { return append(DEFAULT_CONTENT); } }, { children: [(0, jsx_runtime_1.jsx)(plus_20_svg_1.default, {}, void 0), "\uCF58\uD150\uCE20 \uCD94\uAC00"] }), void 0)] }, void 0), (0, jsx_runtime_1.jsxs)(Styled.DeleteButton, __assign({ onClick: handleRemoveSession }, { children: [(0, jsx_runtime_1.jsx)(minus_20_svg_1.default, {}, void 0), "\uC138\uC158 \uC0AD\uC81C"] }), void 0)] }, void 0));
};
exports.default = SessionTemplate;
